import * as React from "react"
import PropTypes from "prop-types"
import { Switch } from "components-design-system"
import "./WorkflowModalHeading.scss"

const WorkflowModalHeading = ({ title, iconText, switchProps, suffix, className }) => {
  const handleClick = () => {
    if (switchProps?.onChange !== undefined) {
      let state = switchProps.checked
      if (switchProps?.checked === undefined) state = false
      switchProps.onChange(!state)
    }
  }

  return (
    <div className={`workflow-modal-heading${className ? " " + className : ""}`}>
      {iconText && <div className="workflow-modal-icon">{iconText}</div>}
      {switchProps && (
        <Switch
          onClick={handleClick}
          checked={switchProps.checked}
          size="large"
        />
      )}
      <div
        onClick={handleClick}
        className="workflow-modal-heading-title"
      >
        {title}
      </div>
      {suffix}
    </div>
  )
}

WorkflowModalHeading.propTypes = {
  iconText: PropTypes.string,
  switchProps: PropTypes.shape({
    checked: PropTypes.bool,
    onChange: PropTypes.func,
  }),
}

export default WorkflowModalHeading
